import axios from 'axios';


const client = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || '/api/',
  json: true
});


class APIClient {

  createContrib(contrib) {
    return client.post('/contribs/', contrib).then(resp => {
        return resp.data
      }
    ).catch((error) => {
      console.log(error);
      if (error.response.status === 403) {
        error.reason = 'CAPTCHA';
      }
      throw error;
    });

    // TODO expired captcha
  }

  getNumberOfContribs() {
    return client.get('/counter').then(resp => {
      return resp.data;
    })
  }

  createSocialShare(share) {
    return client.post('/share', share).then((resp) => {
      return resp.data;
    });
    // TODO intercept captcha error
  }

  getContrib(id) {
    return client.get('/contribs/' + id).then(resp => {
        return resp.data
      }
    );
  }

  getLayer(name) {
    return client.get('/layers/' + name).then(resp => {
      return resp.data
    });
  }

  getHomeTestimonials() {
    return client.get('/hometestimonials').then(resp => {
        return resp.data
      }
    );
  }
}

export default APIClient;
